import { IconNames } from '@shipengine/giger-theme';
import {
    getInsuranceBadgeIconStyles,
    getInsuranceBadgeStyles,
    getInsuranceBadgeTextStyles,
} from './InsuranceSelectBadgeStyles';
import { Icon, Typography } from '@shipengine/giger';
import { Currency, IInsuranceProduct, InsuranceProtectionType } from '@packlink/packlink-sdk';
import { TFunction } from 'i18next';

export enum BadgeColor {
    BASE = 'base',
    GREEN = 'green',
    WARN = 'warn',
}

interface InsuranceSelectBadgeProps {
    text: string;
    icon: IconNames;
    color: BadgeColor;
}

export const getInsuranceBadgeProps = (insurance: IInsuranceProduct, isInsuranceSelected: boolean, t: TFunction) => {
    switch (insurance.protection?.protectionType) {
        case InsuranceProtectionType.NONE:
            return {
                text: t('insurance-select.badge.not-protected'),
                icon: IconNames.SHIELD_DISABLED,
                color: !isInsuranceSelected ? BadgeColor.BASE : BadgeColor.WARN,
            };
        case InsuranceProtectionType.FULL:
            return {
                text: t('insurance-select.badge.full-protected', {
                    amount: Currency.format(insurance?.protection?.value, insurance.currency),
                }),
                icon: IconNames.CARDBOARD_BOX_CHECK,
                color: BadgeColor.GREEN,
            };
        case InsuranceProtectionType.BASIC:
            return !insurance.isEnabled
                ? {
                      text: t('insurance-select.badge.base-protected', {
                          amount: Currency.format(insurance?.protection?.value, insurance.currency),
                      }),
                      icon: IconNames.CARDBOARD_BOX_CHECK,
                      color: BadgeColor.GREEN,
                  }
                : {
                      text: t('insurance-select.badge.base-only', {
                          amount: Currency.format(insurance?.protection?.value, insurance.currency),
                      }),
                      icon: IconNames.SHIELD_DISABLED,
                      color: !isInsuranceSelected ? BadgeColor.BASE : BadgeColor.WARN,
                  };
        case InsuranceProtectionType.MAX:
            return {
                text: t('insurance-select.badge.max', {
                    amount: Currency.format(insurance?.protection?.value, insurance.currency),
                }),
                icon: IconNames.CARDBOARD_BOX_CHECK,
                color: BadgeColor.GREEN,
            };
        default:
            return undefined;
    }
};

export const InsuranceSelectBadge = ({ text, icon, color }: InsuranceSelectBadgeProps) => {
    return (
        <div css={getInsuranceBadgeStyles(color)}>
            <Typography variant="subtitle2" component="p" css={getInsuranceBadgeTextStyles}>
                <Icon name={icon} css={getInsuranceBadgeIconStyles} />
                {text}
            </Typography>
        </div>
    );
};
